import type { OrderDetailsExtended } from 'app/src/model'
import { refundCollection } from 'app/src/msw/refund/initialSeed/refund'
import { apiBaseUrl } from 'app/src/msw/shopping/api/apiBaseUrl'
import {
  discountOrdersCollection,
  getAllOrders,
  giftCardsOrdersCollection,
  goodAndServiceOrdersCollection,
  refundsOrdersCollection,
  vouchersOrdersCollection,
} from 'app/src/msw/shopping/initialSeed/orders'
import { updateCredit } from 'app/src/msw/shopping/utils/updateCredit'
import { http, HttpResponse, type DefaultBodyType } from 'msw'

export const deleteOrder = http.post<{ orderId: string }, DefaultBodyType, undefined>(
  apiBaseUrl + '/orders/:orderId/cancel',
  async ({ params }) => {
    await new Promise((resolve) => setTimeout(resolve, 4000))
    if (params.orderId !== 'CONFIRMED') {
      const order: OrderDetailsExtended | undefined = (await getAllOrders()).find((order) => order.orderId === params.orderId)
      console.log('order', order)

      if (!order) {
        return HttpResponse.text('Order not found', { status: 404 })
      } else {
        if (order.product.typology === 'discount') {
          const discountOrder = discountOrdersCollection.findFirst((q) => q.where({ orderId: params.orderId }))
          if (discountOrder) {
            await discountOrdersCollection.update(discountOrder, {
              data(order) {
                order.status = 'canceled'
              },
            })
          }
        } else if (order.product.typology === 'giftCard') {
          const giftCardOrder = giftCardsOrdersCollection.findFirst((q) => q.where({ orderId: params.orderId }))
          if (giftCardOrder) {
            await giftCardsOrdersCollection.update(giftCardOrder, {
              data(order) {
                order.status = 'canceled'
              },
            })
          }
        } else if (order.product.typology === 'goodAndService') {
          const goodAndServiceOrder = goodAndServiceOrdersCollection.findFirst((q) => q.where({ orderId: params.orderId }))
          if (goodAndServiceOrder) {
            await goodAndServiceOrdersCollection.update(goodAndServiceOrder, {
              data(order) {
                order.status = 'canceled'
              },
            })
          }
        } else if (order.product.typology === 'voucher') {
          const voucherOrder = vouchersOrdersCollection.findFirst((q) => q.where({ orderId: params.orderId }))
          if (voucherOrder) {
            await vouchersOrdersCollection.update(voucherOrder, {
              data(order) {
                order.status = 'canceled'
              },
            })
          }
        } else if (order.product.typology === 'refund') {
          /* find refund order */
          const refundOrder = refundsOrdersCollection.findFirst((q) => q.where({ orderId: params.orderId }))
          /* update credit */
          if (refundOrder) {
            /* update order status */
            await refundsOrdersCollection.update(refundOrder, {
              data(order) {
                order.status = 'canceled'
              },
            })
            /* also update refund status */
            await refundCollection.update((q) => q.where({ attributes: { orderId: params?.orderId as string } }), {
              data(refund) {
                refund.status.value = 'CANCELED'
                refund.status.updatedAt = new Date().toISOString()
                refund.isCancelable = false
              },
            })
          }
        }

        await updateCredit(order, true)

        return HttpResponse.text('The order has been cancelled', { status: 200 })
      }
    } else return HttpResponse.text('The order cannot be cancelled', { status: 400 })
  },
)
